import { Component, ChangeDetectionStrategy, OnChanges, Input } from '@angular/core';
import { TRANSACTION_DIRECTION_STYLE_MAP, IrisCreditDebitIndicator } from '@app/core/types/iris-report';


@Component({
  selector: 'itfg-bank-transaction-direction-icon',
  templateUrl: './bank-transaction-direction-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BankTransactionDirectionIconComponent implements OnChanges {
  @Input() creditDebitIndicator: IrisCreditDebitIndicator;

  icon: string;
  color: string;
  label: string;

  ngOnChanges(): void {
    const config = TRANSACTION_DIRECTION_STYLE_MAP[this.creditDebitIndicator];
    this.icon = config.icon;
    this.color = config.color;
    this.label = config.label;
  }
}